export default "__VITE_ASSET__BPb2_oZ0__"